import { useEffect, useState } from 'react';

import { CookieBanner } from './CookieBanner';
import { CookiePreferences } from './CookiePreferences';
import { useCookiePreferences } from '../CookiePreferencesProvider';

export const CookiePreferencesBanner = () => {
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(false);
  const [isBannerOpen, setIsBannerOpen] = useState(false);

  const cookiePreferences = useCookiePreferences();

  useEffect(() => {
    setIsPreferencesOpen(cookiePreferences?.isPreferencesOpen ?? false);
    setIsBannerOpen(cookiePreferences?.isBannerOpen ?? false);
  }, [cookiePreferences?.isPreferencesOpen, cookiePreferences?.isBannerOpen]);

  /* GDPR: Hiding the banner GDPR because we're not extending GDPR to AU and NZ locales */
  if (!cookiePreferences) return null;

  return (
    <>
      {isPreferencesOpen && (
        <CookiePreferences
          onAccept={cookiePreferences?.handleOnAcceptChoice}
          onRejectAll={cookiePreferences?.handleOnRejectAll}
          onPreferenceClick={cookiePreferences?.handlePreferenceClick}
          preferences={cookiePreferences}
        />
      )}
      {isBannerOpen && (
        <CookieBanner
          onRejectAll={cookiePreferences?.handleOnRejectAll}
          onAcceptAll={cookiePreferences?.handleOnAcceptAll}
          onManagePreferencesClick={cookiePreferences?.handleManagePreferenceClick}
        />
      )}
    </>
  );
};
